import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { CheckmarkCircleFillIcon } from "@navikt/aksel-icons";
import { useTranslation } from "react-i18next";

export const BekreftelseHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="sm:flex gap-6 items-center">
        {/* Hex color code because digdir colors not supported in aksel-icons */}
        <CheckmarkCircleFillIcon
          fontSize={"3rem"}
          color="#23694B"
          className="inline-block"
        />
        <Heading data-size={"lg"}>
          {t("pages.bekreftelse.header.tittel")}
        </Heading>
      </div>
      <Paragraph data-size={"lg"}>
        {t("pages.bekreftelse.header.beskrivelse")}
      </Paragraph>
    </div>
  );
};
